/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/* eslint-disable import/no-unresolved, import/default */

import credentialsTemplate from './credentials.tpl.html';
import selectEntityTemplate from './select-entity.tpl.html';
import applyConfigTemplate from '../json-configuration/json-configuration.tpl.html';
import applyUpgradeTemplate from '../firmware/firmware.tpl.html';
import statusTableTemplate from '../status-table/status-table.tpl.html';
import statisticsTemplate from '../statistics/statistics.tpl.html';
import integrationRetryStatisticsTemplate from '../integration/integration-retry-statistics.tpl.html';
import integrationDeliveryStatisticsTemplate from '../integration/integration-delivery-statistics.tpl.html';
import integrationDlStatisticsTemplate from '../integration/integration-dl-statistics.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function Dialogs($q, $translate, $mdDialog, $document, types) {


    var service = {
        manageCredentials: manageCredentials,
        selectEntity: selectEntity,
        confirm: confirm,
        subscriptionViolation: subscriptionViolation,
        applyConfiguration: applyConfiguration,
        applyUpgrade: applyUpgrade,
        showConfigStatus: showConfigStatus,
        showFirmwareStatus: showFirmwareStatus,
        showStatistics: showStatistics,
        showIntegrationRetryStatistics: showIntegrationRetryStatistics,
        showIntegrationDeliveryStatistics: showIntegrationDeliveryStatistics,
        showIntegrationDlStatistics: showIntegrationDlStatistics
    }

    return service;

    function manageCredentials($event, entity, isReadOnly) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'CredentialsController',
            controllerAs: 'vm',
            templateUrl: credentialsTemplate,
            locals: {entityId: entity.id, isReadOnly: isReadOnly},
            parent: angular.element($document[0].body),
            fullscreen: true,
            targetEvent: $event
        }).then(() => {
        }, () => {
        });
    }

    function selectEntity($event, targetEntityType, selectEntityTitle,
                          confirmSelectTitle, placeholderText, notFoundText, requiredText, onEntitySelected) {
        var deferred = $q.defer();
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'SelectEntityController',
            controllerAs: 'vm',
            templateUrl: selectEntityTemplate,
            locals: {targetEntityType: targetEntityType,
                     selectEntityTitle: selectEntityTitle,
                     confirmSelectTitle: confirmSelectTitle,
                     placeholderText: placeholderText,
                     notFoundText: notFoundText,
                     requiredText: requiredText,
                     onEntitySelected: onEntitySelected
                },
            parent: angular.element($document[0].body),
            fullscreen: true,
            targetEvent: $event,
            multiple: true
        }).then((targetEntityId) => {
            deferred.resolve(targetEntityId);
        }, () => {
            deferred.reject();
        });
        return deferred.promise;
    }

    function confirm($event, title, content, label) {
        if ($event) {
            $event.stopPropagation();
        }
        var confirm = $mdDialog.confirm()
            .targetEvent($event)
            .title(title)
            .htmlContent(content)
            .ariaLabel(label)
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        return $mdDialog.show(confirm);
    }

    function subscriptionViolation($event, rejection) {
        var subscriptionErrorCode = rejection.data.subscriptionErrorCode;
        var subscriptionEntry = rejection.data.subscriptionEntry;
        var value = rejection.data.subscriptionValue;
        var subscriptionErrorText = types.subscriptionError[subscriptionErrorCode][subscriptionEntry];
        var content = $translate.instant(subscriptionErrorText, {value: value});
        var alert = $mdDialog.alert().targetEvent($event)
            .title($translate.instant('subscription-error.title'))
            .htmlContent(content)
            .ariaLabel($translate.instant('subscription-error.title'))
            .ok($translate.instant('action.ok'));
        alert._options.skipHide = true;
        alert._options.fullscreen = true;
        $mdDialog.show(alert);
    }

    function showConfigStatus($event, entities, isGroup) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'StatusTableController',
            controllerAs: 'vm',
            multiple: true,
            templateUrl: statusTableTemplate,
            locals: {
                type: types.entityType.gateway,
                entities: entities,
                isGroup: isGroup
            },
            parent: angular.element($document[0].body),
            fullscreen: true,
            targetEvent: $event,
            autoWrap: false,
            resolve: {
                statusTableConfiguration:
                /*@ngInject*/
                function(jsonConfigurationStatusTableConfig) {
                    return jsonConfigurationStatusTableConfig.getConfig(isGroup);
                 }
            }
        }).then(() => {
        }, () => {
        });
    }

    function showFirmwareStatus($event, entities, type, isGroup) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'StatusTableController',
            controllerAs: 'vm',
            multiple: true,
            templateUrl: statusTableTemplate,
            locals: {
                type: type,
                entities: entities,
                isGroup: isGroup
            },
            parent: angular.element($document[0].body),
            fullscreen: true,
            targetEvent: $event,
            autoWrap: false,
            resolve: {
                statusTableConfiguration:
                /*@ngInject*/
                function(firmwareStatusTableConfig) {
                    return firmwareStatusTableConfig.getConfig(isGroup);
                 }
            }
        }).then(() => {
        }, () => {
        });
    }

    function applyConfiguration($event, entities, type) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'ApplyJsonConfigurationController',
            controllerAs: 'vm',
            templateUrl: applyConfigTemplate,
            locals: {
                type: type,
                entities: entities
            },
            parent: angular.element($document[0].body),
            fullscreen: true,
            targetEvent: $event
        }).then(() => {
        }, () => {
        });
    }

    function applyUpgrade($event, entities, type) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'ApplyFirmwareController',
            controllerAs: 'vm',
            templateUrl: applyUpgradeTemplate,
            locals: {
                type: type,
                entities: entities,
            },
            parent: angular.element($document[0].body),
            fullscreen: true,
            targetEvent: $event
        }).then(() => {
        }, () => {
        });
    }

    function showIntegrationRetryStatistics($event, entity) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'IntegrationRetryStatisticsController',
            controllerAs: 'vm',
            templateUrl: integrationRetryStatisticsTemplate,
            parent: angular.element($document[0].body),
            locals: {
                entityId: entity.id.id,
                entityType: entity.type,
            },
            targetEvent: $event
        }).then(() => {
        }, () => {
        });
    }

    function showIntegrationDeliveryStatistics($event, entity) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'IntegrationDeliveryStatisticsController',
            controllerAs: 'vm',
            templateUrl: integrationDeliveryStatisticsTemplate,
            parent: angular.element($document[0].body),
            locals: {
                entityId: entity.id.id,
            },
            targetEvent: $event
        }).then(() => {
        }, () => {
        });
    }

    function showIntegrationDlStatistics($event, entity) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'IntegrationDlStatisticsController',
            controllerAs: 'vm',
            templateUrl: integrationDlStatisticsTemplate,
            parent: angular.element($document[0].body),
            locals: {
                entityId: entity.id.id,
            },
            targetEvent: $event
        }).then(() => {
        }, () => {
        });
    }

    function showStatistics($event, entity, statisticsConfig) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'StatisticsController',
            controllerAs: 'vm',
            templateUrl: statisticsTemplate,
            parent: angular.element($document[0].body),
            locals: {
                entityId: entity.id.id,
            },
            targetEvent: $event,
            resolve: {
                statisticsConfiguration:
                    /*@ngInject*/
                    function () {
                        return statisticsConfig.getConfig();
                    }
            }
        }).then(() => {
        }, () => {
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/dialog/dialogs.service.js